"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestMetadataSchema = exports.METADATA_HEADER_NAMES = void 0;
exports.serializeRequestMetadata = serializeRequestMetadata;
/**
 * Call-context metadata for oRPC calls, carried over HTTP headers.
 *
 * Three generic fields ride here: `language` (the caller's preferred locale),
 * `clientVersion` (caller build, for analytics correlation), and `url`
 * (originating page, for analytics). These describe the call, not the resource
 * — silo, structure, and instance are resource-identifying and live in URL
 * paths instead (e.g. `POST /api/v2/silo/{siloKey}/spaces`).
 *
 * Only `language` is required. `clientVersion` and `url` are optional — callers
 * that don't have them (or don't want to leak them, e.g. for `url`) can omit
 * them.
 *
 * This module is shared between client and server. The client calls
 * `serializeRequestMetadata` in its RPCLink `headers: () => ...` callback to
 * produce the outgoing header bag. The server runs the corresponding parse
 * (using Hono's `accepts` helper for `Accept-Language`) in
 * `server/orpc/context.ts` and validates the result against
 * `RequestMetadataSchema` defined here. Keeping the schema in one place makes
 * drift between the two sides impossible.
 *
 * A malformed header value that IS present (e.g. a `PSI-Url` that isn't a valid
 * URL) produces a `ZodError` that the server converts into a typed
 * `BAD_REQUEST` (400) — deliberately not a 500, and deliberately never reported
 * to Sentry, since this is a client-side misconfiguration.
 */
const z = __importStar(require("zod"));
const locale_1 = require("../locale");
const api_schemas_1 = require("./api-schemas");
exports.METADATA_HEADER_NAMES = {
    language: 'Accept-Language',
    clientVersion: 'PSI-Client-Version',
    url: 'PSI-Url',
};
exports.RequestMetadataSchema = z.object({
    language: z.enum(locale_1.ALL_ISO_LOCALES).meta({
        description: 'Caller-preferred language. On the wire, sent as a standard `Accept-Language` value (single ISO locale or comma-separated tags with `q=` weights); the server picks the highest-priority tag and parses it as an `IsoLocale`. Falls back to the default locale when missing or unrecognised.',
    }),
    clientVersion: api_schemas_1.shortString.optional().meta({
        description: 'Caller build version. Optional; recorded in analytics when present and useful for correlating client-side bugs.',
    }),
    url: api_schemas_1.urlString.optional().meta({
        description: 'Originating page URL. Optional; recorded in analytics when present. Callers may omit to avoid leaking URL contents.',
    }),
});
function serializeRequestMetadata(metadata) {
    const headers = {
        [exports.METADATA_HEADER_NAMES.language]: metadata.language,
    };
    if (metadata.clientVersion)
        headers[exports.METADATA_HEADER_NAMES.clientVersion] = metadata.clientVersion;
    if (metadata.url)
        headers[exports.METADATA_HEADER_NAMES.url] = metadata.url;
    return headers;
}
//# sourceMappingURL=metadata-headers.js.map